import { Component, OnInit } from '@angular/core';
import {Helper} from '../../../utils/helper.module';
import { ActivatedRoute, Router } from "@angular/router";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {

  token : any = '';
  errorMsg : any = '';
  onloading = false;
  user : any = {
    token : '',
    old_password : '',
    password : '',
    rpassword : ''
  };

  tokenIsValid = false;
  verifyIsDone = false;

  constructor(private route:ActivatedRoute, private http: HttpClient){
    this.route.params.subscribe(params => {
      if (params['token'])
        this.user.token = params['token'];
    });

  }

  ngOnInit() {
    let vm = this;
    this.checkToken().then(function(rsp:any){
      vm.verifyIsDone = true;
      vm.tokenIsValid = rsp.token != undefined;
    });
  }

  public checkToken() {

    return this.http.get(Helper.api('check-token/'+this.user.token))
        .toPromise()
        .then((response) => {
          Promise.resolve(response);
          return Promise.resolve(response);
        }).catch();

  }

  public onSubmit() {
    let vm = this;
    this.onloading = true;
    this.changePassword().then(function(rsp:any){
      vm.onloading = false;
      if(rsp.error == true) vm.errorMsg = rsp.message;
      else window.location.href = '/';
    }).catch(function(){ vm.onloading = false; });
  }

  public changePassword(){
    return this.http.post(Helper.api('change-password'), this.user)
        .toPromise()
        .then((response) => {
          Promise.resolve(response);
          return Promise.resolve(response);
        }).catch();
  }
}
